import React, { useState, useEffect, Fragment } from 'react';
import { get } from '../../Services/http';
import BuyButton from '../BuyButton';
import { translate } from '../../Services/translation';
import { add as addToCartService } from '../../Services/Cart.service';
import { useDispatch } from 'react-redux';
import { receive } from '../../Actions/Cart.action';
import SimplePopup from '../SimplePopUp';
import { useSelector } from 'react-redux';
import { SUBSCRIPTION_INTERVAL_MONTHLY } from '../../constants';
import { GetPacketSizeToAdd } from '../../Services/Cart.service';

const MyPageRecommendation = (props) => {
  const customerRecommendation =
    props.customerRecommendation && JSON.parse(props.customerRecommendation);
  const href = '#';
  const [leftEyePacket, setLeftEyePacket] = useState('');
  const [rightEyePacket, setRightEyePacket] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const cart = useSelector((state) => state.cart);
  const [subscriptionSelected, setsubscriptionSelected] = useState(false);
  const [oneTimeShopSelected, setoneTimeShopSelected] = useState(false);
  const [noOptionSelected, setnoOptionSelected] = useState(true);


  const anyProductNotBuyable = ((customerRecommendation.customerRecommendationItemLeft && !customerRecommendation.customerRecommendationItemLeft.canBuy) ||
  (customerRecommendation.customerRecommendationItemRight && !customerRecommendation.customerRecommendationItemRight.canBuy));

  const handleIsProcessing = async () => {
      setIsProcessing(true);
  };
  
  const handleButtonClick = () => {
    setShowPopup(true);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  }; 

  const dispatch = useDispatch();

  useEffect(() => {
    if (props.subscriptionExists) {
      setsubscriptionSelected(false);
      setoneTimeShopSelected(true);
      setnoOptionSelected(false);
    }    
  }, [props, props.subscriptionExists]);

  let cssClass = ((customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.canBuy) ||
    (customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.canBuy)) && !noOptionSelected
    ? 'button buy-button product-detail__buy-button'
    : 'button buy-button product-detail__buy-button disabled';

  let leftArticleNumber = customerRecommendation.customerRecommendationItemLeft ? customerRecommendation.customerRecommendationItemLeft.articleNumber : "";
  let rightArticleNumber = customerRecommendation.customerRecommendationItemRight ? customerRecommendation.customerRecommendationItemRight.articleNumber : "";

  //customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.packet
  //customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.packet

  useEffect(() => {
    if (customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.packet)
    {
      setLeftEyePacket(customerRecommendation.customerRecommendationItemLeft.packet);
    }
    if (customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.packet)
    {
      setRightEyePacket(customerRecommendation.customerRecommendationItemRight.packet);
    }
    
}, [props.customerRecommendation]);

  const addItemsToCart = async() => {
    try {
      if (customerRecommendation.customerRecommendationItemRight && 
          customerRecommendation.customerRecommendationItemLeft && 
          customerRecommendation.customerRecommendationItemRight.articleNumber ===
          customerRecommendation.customerRecommendationItemLeft.articleNumber) {
            const packetSize = GetPacketSizeToAdd(customerRecommendation.recommendationLensDurationCategory, 
              customerRecommendation.customerRecommendationItemRight.packageSize);
            const cartBoth = await addToCartService({        
              articleNumber: customerRecommendation.customerRecommendationItemRight.articleNumber,
              quantity: 1,
              rightStrength: customerRecommendation.customerRecommendationItemRight.strength,
              rightCurve: customerRecommendation.customerRecommendationItemRight.curve,
              rightDiameter: customerRecommendation.customerRecommendationItemRight.diameter,
              rightCylinder: customerRecommendation.customerRecommendationItemRight.cylinder,
              rightAxis: customerRecommendation.customerRecommendationItemRight.axis,
              rightEyeAdd: customerRecommendation.customerRecommendationItemRight.add,
              rightColor: customerRecommendation.customerRecommendationItemRight.color,
              rightPacket: subscriptionSelected ? packetSize 
              : Number.parseInt(rightEyePacket),
              rightEyeProductNumber: customerRecommendation.customerRecommendationItemRight.eyeProductNumber,
              leftStrength: customerRecommendation.customerRecommendationItemLeft.strength,
              leftCurve: customerRecommendation.customerRecommendationItemLeft.curve,
              leftDiameter: customerRecommendation.customerRecommendationItemLeft.diameter,
              leftCylinder: customerRecommendation.customerRecommendationItemLeft.cylinder,
              leftAxis: customerRecommendation.customerRecommendationItemLeft.axis,
              leftEyeAdd: customerRecommendation.customerRecommendationItemLeft.add,
              leftColor: customerRecommendation.customerRecommendationItemLeft.color,
              leftPacket: subscriptionSelected ? packetSize 
              : Number.parseInt(leftEyePacket),
              leftEyeProductNumber: customerRecommendation.customerRecommendationItemLeft.eyeProductNumber,
              subscription: subscriptionSelected,
              lensDurationCategory: customerRecommendation.recommendationLensDurationCategory,
              serveITRecommendationIdentifier: customerRecommendation.serveITIdentifier
            });
          } else {
            const cartRight = await addToCartService({
              articleNumber: customerRecommendation.customerRecommendationItemRight.articleNumber,
              quantity: 1,
              rightStrength: customerRecommendation.customerRecommendationItemRight.strength,
              rightCurve: customerRecommendation.customerRecommendationItemRight.curve,
              rightDiameter: customerRecommendation.customerRecommendationItemRight.diameter,
              rightCylinder: customerRecommendation.customerRecommendationItemRight.cylinder,
              rightAxis: customerRecommendation.customerRecommendationItemRight.axis,
              rightEyeAdd: customerRecommendation.customerRecommendationItemRight.add,
              rightColor: customerRecommendation.customerRecommendationItemRight.color,
              rightPacket: subscriptionSelected ? GetPacketSizeToAdd(customerRecommendation.recommendationLensDurationCategory, 
                customerRecommendation.customerRecommendationItemRight.packageSize) 
              : rightEyePacket,
              rightEyeProductNumber: customerRecommendation.customerRecommendationItemRight.eyeProductNumber,
              subscription: subscriptionSelected,
              lensDurationCategory: customerRecommendation.recommendationLensDurationCategory,
              serveITRecommendationIdentifier: customerRecommendation.serveITIdentifier
            });
            const cartLeft = await addToCartService({
              articleNumber: customerRecommendation.customerRecommendationItemLeft.articleNumber,
              quantity: 1,
              leftStrength: customerRecommendation.customerRecommendationItemLeft.strength,
              leftCurve: customerRecommendation.customerRecommendationItemLeft.curve,
              leftDiameter: customerRecommendation.customerRecommendationItemLeft.diameter,
              leftCylinder: customerRecommendation.customerRecommendationItemLeft.cylinder,
              leftAxis: customerRecommendation.customerRecommendationItemLeft.axis,
              leftEyeAdd: customerRecommendation.customerRecommendationItemLeft.add,
              leftColor: customerRecommendation.customerRecommendationItemLeft.color,
              leftPacket: subscriptionSelected ? GetPacketSizeToAdd(customerRecommendation.recommendationLensDurationCategory, 
                customerRecommendation.customerRecommendationItemLeft.packageSize) 
              : leftEyePacket,
              leftEyeProductNumber: customerRecommendation.customerRecommendationItemLeft.eyeProductNumber,
              subscription: subscriptionSelected,
              lensDurationCategory: customerRecommendation.recommendationLensDurationCategory,
              serveITRecommendationIdentifier: customerRecommendation.serveITIdentifier
            });
          }
      get(`/api/cart`)
            .then((response) => response.json())
            .then((result) => {
              dispatch(receive(result));              
            });   
      handleButtonClick();
    }
    catch(ex) {
      // Why do we never handle exceptions?
    }
  }

  const getSubscriptionSelectionSection = () => {
    return <div>

      {customerRecommendation.allProductsAvailableForSubscription && !props.subscriptionExists && <a className={` product-detail__selector-link ${(cart.nonSubscriptionProductExists ? " product-detail__packagesize-disabled" : "")}`}
        onClick={() => {
          setsubscriptionSelected(true);
          setoneTimeShopSelected(false);
          setnoOptionSelected(false);
        }}
      >
        <div className="product-detail__typeofpurchase-section subscription">
          <div className="select-wrapper">
            <div className='typeofpurchase'>
              <input type="radio" checked={subscriptionSelected}
                disabled={cart.nonSubscriptionProductExists ||
                  (cart.lensDurationCategoryExistingInCart &&
                    cart.lensDurationCategoryExistingInCart !== customerRecommendation.lensDurationCategory)}></input>
              <p className='name'>{translate("coptikk.product.subscription")}</p>
            </div>
            <p className='price'>{customerRecommendation.pricePerMonth} / {translate("coptikk.checkout.cart.month")}</p>
          </div>
          <div className='description' dangerouslySetInnerHTML={{ __html: translate(
            customerRecommendation.recommendationLensDurationCategory === SUBSCRIPTION_INTERVAL_MONTHLY ?
            "coptikk.subscription.mypages.recommendation.descriptionmonthly" : "coptikk.subscription.mypages.recommendation.descriptiondaily")}}>            
          </div>
        </div>
      </a>}

      {!(cart?.subscriptionExistsForLeftEye || cart?.subscriptionExistsForRightEye) && <a className={` product-detail__selector-link ${((cart.subscriptionExistsForRightEye || cart.subscriptionExistsForLeftEye)
        ? " product-detail__packagesize-disabled" : "")}`}
        onClick={() =>  { 
          setoneTimeShopSelected(true);
          setsubscriptionSelected(false);
          setnoOptionSelected(false);
        }}
      >
        <div className="product-detail__typeofpurchase-section">
          <div className="select-wrapper">
            <div className='typeofpurchase'>
              <input type="radio" checked={oneTimeShopSelected}
                className={`product-detail__article-check`}
                disabled={(cart.subscriptionExistsForRightEye || cart.subscriptionExistsForLeftEye)}></input>
              <p className='name'>{translate("coptikk.product.onlyonetimeshop")}</p>
            </div>
            <p className='price'>{customerRecommendation.totalPrice}</p>
          </div>
        </div>
      </a>}

    </div>
  }

  return (
    <Fragment>
      {showPopup && (
          <SimplePopup onClose={handleClosePopup} checkoutUrl={props.checkoutUrl}/>
      )}
      <div key={`${leftArticleNumber}${rightArticleNumber}`} className={leftArticleNumber === rightArticleNumber ? 'my-recommendations__container' : 'my-recommendations__container-column'}>
        {
          customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.articleNumber &&
          <div>
            <div className='row my-recommendations__product'>
              <div className='columns small-2 my-recommendations__product-image'>
                <img src={customerRecommendation.customerRecommendationItemRight.productImageUrl}></img>
              </div>
              <div className='columns small-6 my-recommendations__eye-spec-wrapper'>
                <div className='my-recommendations__product-name'>
                  {customerRecommendation.customerRecommendationItemRight.name}
                </div>
                <div className='my-recommendations__product-category'>
                  {customerRecommendation.customerRecommendationItemRight.categoryName}
                </div>
                <div className='row'>
                  <div className='column small-8 my-recommendations__eye'>
                    {translate('coptikk.product.righteye')}
                  </div>
                </div>
                <div className='row'>
                  <div className={leftArticleNumber !== rightArticleNumber ? 'column small-8 my-recommendations__spec-row' : 'column small-12 my-recommendations__spec-row'}>
                    {customerRecommendation.customerRecommendationItemRight.strength && <span className='my-recommendations__spec'>{customerRecommendation.customerRecommendationItemRight.strength}</span>}
                    {customerRecommendation.customerRecommendationItemRight.curve &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.curve.short')}: {customerRecommendation.customerRecommendationItemRight.curve}</span>}
                    {customerRecommendation.customerRecommendationItemRight.diameter &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.diameter.short')}: {customerRecommendation.customerRecommendationItemRight.diameter}</span>}
                    {customerRecommendation.customerRecommendationItemRight.cylinder &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.cylinder.short')}: {customerRecommendation.customerRecommendationItemRight.cylinder}</span>}
                    {customerRecommendation.customerRecommendationItemRight.axis &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.axis')}: {customerRecommendation.customerRecommendationItemRight.axis}</span>}
                    {customerRecommendation.customerRecommendationItemRight.add &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.addfield')}: {customerRecommendation.customerRecommendationItemRight.add}</span>}
                    {customerRecommendation.customerRecommendationItemRight.color &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.color')}: {customerRecommendation.customerRecommendationItemRight.color}</span>}
                  </div>
                </div>
                <div className='row'>
                      <div className={leftArticleNumber === rightArticleNumber ? 'column small-6' : 'column small-3'}>
                        <select value={rightEyePacket} onChange={(e) => setRightEyePacket(e.target.value)}>
                          {customerRecommendation.customerRecommendationItemRight.packetList.map(x => {
                            return <option value={x}>{x} {translate('coptikk.price.unit')} {customerRecommendation.customerRecommendationItemRight.price},-</option>
                          })}
                        </select>
                      </div>
                </div>
              </div>
            </div>
          </div>
        }
        {
          customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.articleNumber &&
          <div>
            <div className='row my-recommendations__product'>
              {(leftArticleNumber !== rightArticleNumber) && <div className='columns small-2 my-recommendations__product-image'>
                <img src={customerRecommendation.customerRecommendationItemLeft.productImageUrl}></img>
              </div>}
              <div className='columns small-6 my-recommendations__eye-spec-wrapper'>
                {(leftArticleNumber !== rightArticleNumber) && <div className='my-recommendations__product-name'>
                  {customerRecommendation.customerRecommendationItemLeft.name}
                </div>}
                {(leftArticleNumber !== rightArticleNumber) && <div className='my-recommendations__product-category'>
                  {customerRecommendation.customerRecommendationItemLeft.categoryName}
                </div>}
                <div className='row'>
                  <div className='column small-8 my-recommendations__eye'>
                    {translate('coptikk.product.lefteye')}
                  </div>
                </div>
                <div className='row'>
                  <div className={leftArticleNumber !== rightArticleNumber ? 'column small-8 my-recommendations__spec-row' : 'column small-12 my-recommendations__spec-row'}>
                    {customerRecommendation.customerRecommendationItemLeft.strength && <span className='my-recommendations__spec'>{customerRecommendation.customerRecommendationItemLeft.strength}</span>}
                    {customerRecommendation.customerRecommendationItemLeft.curve &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.curve.short')}: {customerRecommendation.customerRecommendationItemLeft.curve}</span>}
                    {customerRecommendation.customerRecommendationItemLeft.diameter &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.diameter.short')}: {customerRecommendation.customerRecommendationItemLeft.diameter}</span>}
                    {customerRecommendation.customerRecommendationItemLeft.cylinder &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.cylinder.short')}: {customerRecommendation.customerRecommendationItemLeft.cylinder}</span>}
                    {customerRecommendation.customerRecommendationItemLeft.axis &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.axis')}: {customerRecommendation.customerRecommendationItemLeft.axis}</span>}
                    {customerRecommendation.customerRecommendationItemLeft.add &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.addfield')}: {customerRecommendation.customerRecommendationItemLeft.add}</span>}
                    {customerRecommendation.customerRecommendationItemLeft.color &&
                      <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.color')}: {customerRecommendation.customerRecommendationItemLeft.color}</span>}
                  </div>
                </div>
                <div className='row'>
                      <div className={leftArticleNumber === rightArticleNumber ? 'column small-6' : 'column small-3'}>
                        <select value={leftEyePacket} onChange={(e) => setLeftEyePacket(e.target.value)}>
                          {customerRecommendation.customerRecommendationItemLeft.packetList.map(x => {
                            return <option value={x}>{x} {translate('coptikk.price.unit')} {customerRecommendation.customerRecommendationItemLeft.price},-</option>
                          })}
                        </select>
                      </div>
                </div>
              </div>
            </div>
          </div>
        }        
        {((leftArticleNumber === rightArticleNumber) || 
          (leftArticleNumber === "" && rightArticleNumber !== "") || 
          (leftArticleNumber !== "" && rightArticleNumber === "")) && 
          (customerRecommendation.customerRecommendationItemRight &&
            customerRecommendation.customerRecommendationItemRight.strength &&
            customerRecommendation.customerRecommendationItemRight.curve &&
            customerRecommendation.customerRecommendationItemRight.diameter ||

            customerRecommendation.customerRecommendationItemLeft &&
            customerRecommendation.customerRecommendationItemLeft.strength &&
            customerRecommendation.customerRecommendationItemLeft.curve &&
            customerRecommendation.customerRecommendationItemLeft.diameter) ? 
        <div className="my-recommendations__buy-button-wrapper">
            {getSubscriptionSelectionSection()}
            <BuyButton
              label={customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft !== null ? 
                customerRecommendation.customerRecommendationItemLeft.label : 
                customerRecommendation.customerRecommendationItemRight.label}
              articleNumber={leftArticleNumber ? leftArticleNumber : rightArticleNumber}
              href={href}
              cssClass={
                (leftEyePacket !== '0' || rightEyePacket !== '0' || isProcessing)
                  ? cssClass
                  : `${cssClass} ${(anyProductNotBuyable || noOptionSelected) ? " disabled" : ""} `
              }
              handleBuyButtonClick={handleButtonClick}
              handleIsProcessing={handleIsProcessing}
              setIsProcessing={setIsProcessing}
              rightStrength={customerRecommendation.customerRecommendationItemRight ? customerRecommendation.customerRecommendationItemRight.strength : ""}
              rightCurve={customerRecommendation.customerRecommendationItemRight ? customerRecommendation.customerRecommendationItemRight.curve : ""}
              rightDiameter={customerRecommendation.customerRecommendationItemRight ? customerRecommendation.customerRecommendationItemRight.diameter : ""}
              rightCylinder={customerRecommendation.customerRecommendationItemRight ? customerRecommendation.customerRecommendationItemRight.cylinder : ""}
              rightAxis={customerRecommendation.customerRecommendationItemRight ? customerRecommendation.customerRecommendationItemRight.axis : ""}
              rightEyeAdd={customerRecommendation.customerRecommendationItemRight ? customerRecommendation.customerRecommendationItemRight.add : ""}
              rightColor={customerRecommendation.customerRecommendationItemRight ? customerRecommendation.customerRecommendationItemRight.color : ""}
              rightPacket={customerRecommendation.customerRecommendationItemRight ? (subscriptionSelected ? GetPacketSizeToAdd(customerRecommendation.recommendationLensDurationCategory, 
                customerRecommendation.customerRecommendationItemRight.packageSize) : rightEyePacket) : ""}
              rightCylinderHasOptions={customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.cylinder}
              rightAxisHasOptions={customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.axis}
              rightAddHasOptions={customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.add}
              rightColorHasOptions={customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.color}
              rightEyeProductNumber={customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.eyeProductNumber}

              leftStrength={customerRecommendation.customerRecommendationItemLeft ? customerRecommendation.customerRecommendationItemLeft.strength : ""}
              leftCurve={customerRecommendation.customerRecommendationItemLeft ? customerRecommendation.customerRecommendationItemLeft.curve : ""}
              leftDiameter={customerRecommendation.customerRecommendationItemLeft ? customerRecommendation.customerRecommendationItemLeft.diameter : ""}
              leftCylinder={customerRecommendation.customerRecommendationItemLeft ? customerRecommendation.customerRecommendationItemLeft.cylinder : ""}              
              leftAxis={customerRecommendation.customerRecommendationItemLeft ? customerRecommendation.customerRecommendationItemLeft.axis : ""}              
              leftEyeAdd={customerRecommendation.customerRecommendationItemLeft ? customerRecommendation.customerRecommendationItemLeft.add : ""}              
              leftColor={customerRecommendation.customerRecommendationItemLeft ? customerRecommendation.customerRecommendationItemLeft.color : ""}     
              leftPacket={customerRecommendation.customerRecommendationItemLeft ? (subscriptionSelected ? GetPacketSizeToAdd(customerRecommendation.recommendationLensDurationCategory, 
                customerRecommendation.customerRecommendationItemLeft.packageSize) : leftEyePacket) : ""}                       
              leftCylinderHasOptions={customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.cylinder}
              leftAxisHasOptions={customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.axis}
              leftAddHasOptions={customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.add}  
              leftColorHasOptions={customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.color} 
              leftEyeProductNumber={customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.eyeProductNumber}
              
              excludeRightValidations={!customerRecommendation.customerRecommendationItemRight}
              excludeLeftValidations={!customerRecommendation.customerRecommendationItemLeft}
              subscription={subscriptionSelected}
              lensDurationCategory={customerRecommendation.recommendationLensDurationCategory}
              serveITRecommendationIdentifier={customerRecommendation.serveITIdentifier}
            />             
            {(leftEyePacket === '0' || rightEyePacket === '0') && (
              <div>
                {translate('coptikk.product.youmustselect')}{' '}
                {translate('coptikk.product.packets')}
              </div>
            )}
          </div> : <div className="my-recommendations__buy-button-wrapper disabled">
            {getSubscriptionSelectionSection()} 
            <button className={`button buy-button ${(anyProductNotBuyable || noOptionSelected)  ? "  disabled" : ""}`}
              onClick={() => (anyProductNotBuyable || noOptionSelected) ? "" : addItemsToCart()}
              >
              {translate('coptikk.product.buy')}
            </button>
            {anyProductNotBuyable ? 
            <p className='contact-text'>{translate('coptikk.mypage.notbuyable.description')}</p> : ""
            }
          </div>}
      </div>
    </Fragment>
  );
};

export default MyPageRecommendation;
